export default "__VITE_ASSET__DwjjEeOW__"